module.exports = __webpack_public_path__ + "static/media/step-small-blank-mobile.89e42a1e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/step-small-blank-mobile.svg
// module id = 860
// module chunks = 21